'use client';

import type { ReactNode, SetStateAction, Dispatch } from 'react';
import { createContext, useState } from 'react';

export const PageTransitionContext = createContext<boolean>(false);

export const PageTransitionDispatchContext = createContext<Dispatch<SetStateAction<boolean>>>(
  () => {},
);

export const PageTransitionProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);

  return (
    <PageTransitionContext.Provider value={loading}>
      <PageTransitionDispatchContext.Provider value={setLoading}>
        {children}
      </PageTransitionDispatchContext.Provider>
    </PageTransitionContext.Provider>
  );
};
